import { Link as RouterLink, useLocation } from 'react-router-dom';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from '@mui/material';
import logo from '../../assets/logo.png';

function Navbar({ navLinks, companyInfo, onMenuClick }) {
  const { pathname } = useLocation();

  const isActive = (path) => (path === '/' ? pathname === path : pathname.startsWith(path));

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: 1300,
        minHeight: 64,
        bgcolor: 'rgba(26,5,51,0.97)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(201,168,76,0.14)',
      }}
    >
      <Container maxWidth={false}>
        <Toolbar sx={{ minHeight: '64px !important', px: { xs: 0.5, md: 2 } }}>
          <Stack direction="row" spacing={1.25} alignItems="center" sx={{ flexGrow: 1, minWidth: 0 }}>
            <IconButton onClick={onMenuClick} sx={{ color: '#ffffff' }}>
              <MenuRoundedIcon />
            </IconButton>
            <Box
              component="img"
              src={logo}
              alt={`${companyInfo.name} logo`}
              sx={{
                width: 52,
                height: 42,
                objectFit: 'contain',
                borderRadius: 1.5,
                bgcolor: '#ffffff',
                border: '1px solid rgba(201,168,76,0.26)',
              }}
            />
            <Box sx={{ minWidth: 0 }}>
              <Typography sx={{ color: '#ffffff', fontWeight: 900, lineHeight: 1.05, fontSize: { xs: '0.9rem', md: '1rem' } }}>
                {companyInfo.name}
              </Typography>
              <Typography sx={{ color: '#c9a84c', fontSize: '0.68rem', letterSpacing: 1.5, textTransform: 'uppercase' }}>
                {companyInfo.tagline}
              </Typography>
            </Box>
          </Stack>

          <Stack direction="row" spacing={0.5} sx={{ display: { xs: 'none', md: 'flex' }, mr: 2 }}>
            {navLinks.map((link) => (
              <Button
                key={link.path}
                component={RouterLink}
                to={link.path}
                sx={{
                  color: isActive(link.path) ? '#c9a84c' : '#ffffff',
                  borderBottom: isActive(link.path) ? '2px solid #c9a84c' : '2px solid transparent',
                  borderRadius: 0,
                  px: 1.5,
                }}
              >
                {link.label}
              </Button>
            ))}
          </Stack>

          <Button
            component={RouterLink}
            to="/franchise"
            variant="outlined"
            color="secondary"
            sx={{
              borderColor: 'rgba(201,168,76,0.7)',
              color: '#c9a84c',
              display: { xs: 'none', sm: 'inline-flex' },
            }}
          >
            {companyInfo.enquiryLabel}
          </Button>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Navbar;
